<app-lfsa-card *ngIf="mostrarCard" [innTemplate]="datosRequisicion" [titulo]="'DATOS DE CONSULTA'" [efecto]="true"
  [colapseName]="'datosRequisicion'" [banderaColapse]='true'></app-lfsa-card>
<ng-template #datosRequisicion>

  <div class="row" *ngIf="!listaVacia">
    <div class="'col-md-12'">
      <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
  </div>

  <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
  <div *ngIf="!loading">
    <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
      No existen datos para la lista de Documentos.
    </div>
    <ag-grid-angular *ngIf="!listaVacia" #agGrid class="{{empModulo.agGrid.class}}" 
      [ngStyle]="empModulo.agGrid.style" id="{{empModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents "
      [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)"
      [pagination]="true" [paginationPageSize]="empModulo.agGrid.paginacion">
    </ag-grid-angular>
  </div>
  <br>
</ng-template>

<app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
<div *ngIf="!loading" class="row">
  <div class="form-group col-md-12">
    <button [routerLink]="['/emp/sstma/home']"
      class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
  </div>
</div>
<!-- MODAL -->
<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Documentación Rechazada'" [idButton]="'abrirModal'" [idOpen]="'Modal'"
  [idClose]="'cerrarModal'"></app-lfsa-modal>
  
<ng-template #enviarModal>
  <form [formGroup]="formularioEmp" novalidate class="form-group">

    <div class="row">
      <div class="'col-md-6'">
        <h5> <b>Nombres:</b>&nbsp; {{ EmpleadoModal.nombres }} </h5>
      </div>
      <div class="'col-md-6'">
        <h5><b>C.C:</b>&nbsp; {{ EmpleadoModal.cedula }} </h5>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-12">
        <label class="letrasDanger" for="">Observación*</label>
        <textarea placeholder="Observación MAX 250 Caracteres (Obligatorio)"
          class="form-control rounded-0"
          [ngClass]="{'is-invalid': formularioEmp.get('observacion').invalid && formularioEmp.get('observacion').dirty, 'is-valid': formularioEmp.get('observacion').valid}"
          rows="2" formControlName="observacion">
        </textarea>
          <!--(input)="this.formularioEmp.patchValue({observacion: $event.target.value.toUpperCase()})"-->
        <app-lfsa-error-msg [control]="this.formularioEmp.get('observacion')" [label]="">
        </app-lfsa-error-msg>
      </div>
      <!-- {{ formularioEmp.value | json}} -->
      <div class="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioEmp.invalid"
            (click)="guardarNO()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- {{ rowData | json }} -->
<br>